"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEqpTypeToModalityDash = parseEqpTypeToModalityDash;
exports.parseEqpTypeToModality = parseEqpTypeToModality;
const dashboard_1 = require("./dashboard");
const models_1 = require("./models");
function parseEqpTypeToModalityDash(equipmentType) {
    switch (equipmentType) {
        case dashboard_1.DashboardEquipmentType.Cycle:
            return 'bike';
        case dashboard_1.DashboardEquipmentType.Run:
            return 'treadmill';
        case dashboard_1.DashboardEquipmentType.Rower:
            return 'rower';
        case dashboard_1.DashboardEquipmentType.Fusion:
        case dashboard_1.DashboardEquipmentType.Strength:
            return 'strength';
        default:
            return 'any';
    }
}
function parseEqpTypeToModality(equipmentType) {
    switch (equipmentType) {
        case models_1.EquipmentType.Rower:
            return 'rower';
        case models_1.EquipmentType.Fusion:
        case models_1.EquipmentType.Mirror:
        case models_1.EquipmentType.Shoes:
        case models_1.EquipmentType.Strength:
        case models_1.EquipmentType.Vault:
        case models_1.EquipmentType.Yoga:
        case models_1.EquipmentType.Mind:
            return 'strength';
        case models_1.EquipmentType.Bike:
        case models_1.EquipmentType.StudioBike:
        case models_1.EquipmentType.TDFBike:
        case models_1.EquipmentType.SpinBike:
        case models_1.EquipmentType.StationaryBike:
            return 'bike';
        case models_1.EquipmentType.Elliptical:
        case models_1.EquipmentType.FreeStrider:
        case models_1.EquipmentType.Stepper:
        case models_1.EquipmentType.Strider:
        case models_1.EquipmentType.VerticalElliptical:
            return 'elliptical';
        case models_1.EquipmentType.InclineTrainer:
        case models_1.EquipmentType.Treadmill:
            return 'treadmill';
        default:
            return 'any';
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWxpdHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvbW9kYWxpdHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFJQSxnRUFjQztBQUVELHdEQThCQztBQWpERCwyQ0FBcUQ7QUFDckQscUNBQXlDO0FBRXpDLFNBQWdCLDBCQUEwQixDQUFDLGFBQThDO0lBQ3ZGLFFBQVEsYUFBYSxFQUFFLENBQUM7UUFDdEIsS0FBSyxrQ0FBc0IsQ0FBQyxLQUFLO1lBQy9CLE9BQU8sTUFBcUIsQ0FBQztRQUMvQixLQUFLLGtDQUFzQixDQUFDLEdBQUc7WUFDN0IsT0FBTyxXQUEwQixDQUFDO1FBQ3BDLEtBQUssa0NBQXNCLENBQUMsS0FBSztZQUMvQixPQUFPLE9BQXNCLENBQUM7UUFDaEMsS0FBSyxrQ0FBc0IsQ0FBQyxNQUFNLENBQUM7UUFDbkMsS0FBSyxrQ0FBc0IsQ0FBQyxRQUFRO1lBQ2xDLE9BQU8sVUFBeUIsQ0FBQztRQUNuQztZQUNFLE9BQU8sS0FBb0IsQ0FBQztJQUNoQyxDQUFDO0FBQ0gsQ0FBQztBQUVELFNBQWdCLHNCQUFzQixDQUFDLGFBQTRCO0lBQ2pFLFFBQVEsYUFBYSxFQUFFLENBQUM7UUFDdEIsS0FBSyxzQkFBYSxDQUFDLEtBQUs7WUFDdEIsT0FBTyxPQUFzQixDQUFDO1FBQ2hDLEtBQUssc0JBQWEsQ0FBQyxNQUFNLENBQUM7UUFDMUIsS0FBSyxzQkFBYSxDQUFDLE1BQU0sQ0FBQztRQUMxQixLQUFLLHNCQUFhLENBQUMsS0FBSyxDQUFDO1FBQ3pCLEtBQUssc0JBQWEsQ0FBQyxRQUFRLENBQUM7UUFDNUIsS0FBSyxzQkFBYSxDQUFDLEtBQUssQ0FBQztRQUN6QixLQUFLLHNCQUFhLENBQUMsSUFBSSxDQUFDO1FBQ3hCLEtBQUssc0JBQWEsQ0FBQyxJQUFJO1lBQ3JCLE9BQU8sVUFBeUIsQ0FBQztRQUNuQyxLQUFLLHNCQUFhLENBQUMsSUFBSSxDQUFDO1FBQ3hCLEtBQUssc0JBQWEsQ0FBQyxVQUFVLENBQUM7UUFDOUIsS0FBSyxzQkFBYSxDQUFDLE9BQU8sQ0FBQztRQUMzQixLQUFLLHNCQUFhLENBQUMsUUFBUSxDQUFDO1FBQzVCLEtBQUssc0JBQWEsQ0FBQyxjQUFjO1lBQy9CLE9BQU8sTUFBcUIsQ0FBQztRQUMvQixLQUFLLHNCQUFhLENBQUMsVUFBVSxDQUFDO1FBQzlCLEtBQUssc0JBQWEsQ0FBQyxXQUFXLENBQUM7UUFDL0IsS0FBSyxzQkFBYSxDQUFDLE9BQU8sQ0FBQztRQUMzQixLQUFLLHNCQUFhLENBQUMsT0FBTyxDQUFDO1FBQzNCLEtBQUssc0JBQWEsQ0FBQyxrQkFBa0I7WUFDbkMsT0FBTyxZQUEyQixDQUFDO1FBQ3JDLEtBQUssc0JBQWEsQ0FBQyxjQUFjLENBQUM7UUFDbEMsS0FBSyxzQkFBYSxDQUFDLFNBQVM7WUFDMUIsT0FBTyxXQUEwQixDQUFDO1FBQ3BDO1lBQ0UsT0FBTyxLQUFvQixDQUFDO0lBQ2hDLENBQUM7QUFDSCxDQUFDIn0=